// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class BasicEnrollmentRequest {
    static getAttributeTypeMap() {
        return BasicEnrollmentRequest.attributeTypeMap;
    }
}
BasicEnrollmentRequest.discriminator = undefined;
BasicEnrollmentRequest.additionalProperties = false;
BasicEnrollmentRequest.attributeTypeMap = [
    {
        "name": "patient",
        "baseName": "patient",
        "type": "BasicEnrollmentPatient"
    },
    {
        "name": "medicalPayors",
        "baseName": "medicalPayors",
        "type": ""
    },
    {
        "name": "pharmacyPayors",
        "baseName": "pharmacyPayors",
        "type": ""
    },
    {
        "name": "pharmacies",
        "baseName": "pharmacies",
        "type": ""
    },
    {
        "name": "prescribers",
        "baseName": "prescribers",
        "type": ""
    },
    {
        "name": "prescriptions",
        "baseName": "prescriptions",
        "type": ""
    },
    {
        "name": "sites",
        "baseName": "sites",
        "type": ""
    },
    {
        "name": "surveys",
        "baseName": "surveys",
        "type": ""
    },
    {
        "name": "diagnosisCodes",
        "baseName": "diagnosisCodes",
        "type": ""
    },
    {
        "name": "enrollmentPaymentType",
        "baseName": "enrollmentPaymentType",
        "type": "BasicEnrollmentPaymentType"
    },
    {
        "name": "thirdPartyCaseId",
        "baseName": "thirdPartyCaseId",
        "type": "string"
    },
    {
        "name": "thirdPartyEnrollmentId",
        "baseName": "thirdPartyEnrollmentId",
        "type": "string"
    },
    {
        "name": "caseInitiator",
        "baseName": "caseInitiator",
        "type": "EnrollPatientCaseInitiator"
    },
    {
        "name": "caseSource",
        "baseName": "caseSource",
        "type": "EnrollPatientCaseSource"
    },
];
//# sourceMappingURL=basicEnrollmentRequest.js.map